var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2435_146014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 12.98L21.6305 17.1L26.0505 17.37L22.6305 20.19L23.7405 24.48L20.0005 22.1L16.2605 24.48L17.3705 20.19L13.9505 17.37L18.3705 17.1L20.0005 12.98ZM20.0005 11.83C19.5305 11.83 19.1005 12.12 18.9305 12.56L17.5705 16L13.8805 16.23C13.4105 16.26 13.0005 16.57 12.8605 17.02C12.7105 17.47 12.8605 17.96 13.2205 18.26L16.0705 20.62L15.1505 24.2C15.0305 24.66 15.2105 25.14 15.5905 25.42C15.7905 25.57 16.0305 25.64 16.2705 25.64C16.4805 25.64 16.7005 25.58 16.8905 25.46L20.0105 23.47L23.1305 25.46C23.3205 25.58 23.5305 25.64 23.7505 25.64C23.9905 25.64 24.2205 25.57 24.4305 25.42C24.8105 25.14 24.9905 24.66 24.8705 24.2L23.9505 20.62L26.8005 18.26C27.1605 17.96 27.3105 17.47 27.1605 17.02C27.0105 16.57 26.6105 16.26 26.1405 16.23L22.4505 16L21.0905 12.56C20.9205 12.12 20.4905 11.83 20.0205 11.83H20.0005Z",
    fill: "#00000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9395 22.85C30.8895 20 31.4595 16.38 31.4595 11.69C26.3295 11.69 19.9895 6 19.9895 6C19.9895 6 13.6495 11.69 8.51953 11.69C8.51953 27.31 14.9395 31.1 19.9895 34C20.7095 33.59 21.4595 33.15 22.2095 32.67",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5596 27.7C28.0496 26.99 28.5196 26.2 28.9396 25.33",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21 31.26C24.88 30.72 25.54 30.12 26.18 29.43",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2435_146014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpower);
export default __webpack_public_path__ + "static/media/Empower.144527e961559a72496b9e5e943522cc.svg";
export { ForwardRef as ReactComponent };